<template>
  <form @submit.prevent="onSubmit" dir="rtl">

    <h4 class="text-center" v-if="item != null">ویرایش: {{ item.timable.name }}
      ({{ TimingFilters[item.timable_type.toUpperCase()].label }})</h4>

    <form-group class="col-lg-12 col-md-12 mb-3 text-right" :validations="$v.form.timable_type">
      <div slot-scope="{ errors, invalid }">
        <label>نوع زمان بندی</label>
        <b-form-select @change="dataLoader()" class="col-lg-12" v-model="form.timable_type"
                       :options="timingTypeOptions"></b-form-select>
        <form-errors-manager :errors="errors"/>
      </div>
    </form-group>

    <b-row class="my-3">
      <form-group class="col-lg-12 col-md-12  text-right" :validations="$v.form.timableDate">
        <div slot-scope="{ errors, invalid }">
          <label>بازه تاریخی</label>
          <date-picker range clearable auto-submit v-model="form.timableDate"
                       placeholder="بازه تاریخی را انتخاب کنید"
                       format="YYYY-MM-DD" :min="nowDate" display-format="jYYYY/jM/jD"/>

          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>


    </b-row>

    <b-row class="my-3">
      <form-group class="col-lg-6 col-md-6  text-right" :validations="$v.form.open_at">
        <div slot-scope="{ errors, invalid }">
          <label>شروع ساعت</label>
          <date-picker format="HH:mm:ss" clearable v-model="form.open_at" type="time"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group class="col-lg-6 col-md-6  text-right" :validations="$v.form.close_at">
        <div slot-scope="{ errors, invalid }">
          <label>پایان ساعت</label>
          <date-picker :min="form.open_at" format="HH:mm:ss" clearable v-model="form.close_at" type="time"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>
    </b-row>


    <b-row class="my-3">


      <form-group class="col-lg-12 col-md-12 mb-3 text-right" :validations="$v.form.timable_id">
        <div slot-scope="{ errors, invalid }">
          <label>ایتم زمان بندی</label>
          <form @submit.prevent="dataSearch()">
            <b-form-input class="col-lg-12 mb-1" v-model="searchWords" placeholder="جست و جو"></b-form-input>
          </form>
          <select class="custom-select" v-model="form.timable_id">
            <option value="">ایتم مورد نظر را انتخاب کنید</option>
            <option v-for="item in dataGetter()" :value="item.id">{{ item.name }}</option>
          </select>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

    </b-row>

    <b-row class="my-3" v-if="item == null">
      <div class="form-check mr-3">
        <input v-model="repeatTimable" class="ml-1" type="checkbox" value="" id="repeatTimable">
        <label class="form-check-label" for="repeatTimable">
          تکرار دامنه زمانی در بازه تاریخی انتخاب شده.
        </label>

      </div>
    </b-row>

    <b-row class="my-5">
      <b-col lg="12" class="mx-auto text-center">
        <b-button class="w-50" type="submit" pill variant="primary">ثبت</b-button>
      </b-col>
    </b-row>


  </form>
</template>

<script>
import FormGroup from "../../validator/FormGroup";
import FormErrorsManager from "../../validator/FormErrorsManager";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import {getNowString, TimingFilters} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Timing";
import {required} from "vuelidate/lib/validators";

export default {
  name: "CreateForm",
  props: {
    item: {
      default: null
    },
    filters: {
      default: null
    },
    page: {
      default: 1
    }
  },
  components: {
    FormGroup,
    FormErrorsManager,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      form: {
        timableDate: '',
        open_at: '',
        close_at: '',
        timable_type: 'product',
        timable_id: '',
      },
      repeatTimable: false,
      searchWords: '',
      TimingFilters,
      nowDate: getNowString(),
      moduleMethods: {
        brand: {
          data: 'Brand/getBrands',
          search: 'Brand/searchBrand',
          getter: 'Brand/getBrands'
        },
        product: {
          data: 'Product/setProducts',
          search: 'Product/searchProduct',
          getter: 'Product/getProducts'
        },
        category: {
          data: 'Category/getCategories',
          search: 'Category/search',
          getter: 'Category/getCategories'
        }
      },
    }
  },
  computed: {
    timingTypeOptions() {
      let timingTypes = []
      Object.keys(this.TimingFilters).forEach(item => {
        let base = this.TimingFilters[item];
        timingTypes.push({value: base.value, text: base.label})
      })
      return timingTypes
    },
    typeAttribute() {
      return this.moduleMethods[this.form.timable_type]
    },
  },
  validations: {
    form: {
      timableDate: {required},
      open_at: {required},
      close_at: {required},
      timable_type: {required},
      timable_id: {required},
    }
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    formatDate(date) {
      var d = date.getDate();
      var m = date.getMonth() + 1; //Month from 0 to 11
      var y = date.getFullYear();
      return '' + y + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
    },
    getDatesInRange(startDate, endDate) {
      const date = new Date(startDate.getTime());

      const dates = [];

      while (date <= endDate) {
        dates.push(new Date(date));
        date.setDate(date.getDate() + 1);
      }

      return dates;
    },
    generateDataAndTime() {
      let dateAndTimes = new FormData();
      const open_at = new Date(this.form.timableDate[0]);
      const close_at = new Date(this.form.timableDate[1]);
      let dates = this.getDatesInRange(open_at, close_at);

      dates.forEach((item, index) => {

        const item_date = this.formatDate(item);

        dateAndTimes.append(`timings[${index}][open_at]`, item_date + ' ' + this.form.open_at);
        dateAndTimes.append(`timings[${index}][close_at]`, item_date + ' ' + this.form.close_at);
        dateAndTimes.append(`timings[${index}][timable_type]`, this.form.timable_type);
        dateAndTimes.append(`timings[${index}][timable_id]`, this.form.timable_id);

      })

      return dateAndTimes

    },
    async createTimable() {
      let form = {};

      if (this.repeatTimable) {
        let dates = this.generateDataAndTime();
        await this.$store.dispatch("Timing/crateMultipleTiming", dates)
      } else {

        form = {
          timable_type: this.form.timable_type,
          timable_id: this.form.timable_id,
          open_at: this.form.timableDate[0] + ' ' + this.form.open_at,
          close_at: this.form.timableDate[1] + ' ' + this.form.close_at,
        }
        await this.$store.dispatch("Timing/crateTiming", form)

      }

      await this.$store.dispatch('Timing/getTimings', {page: this.page, form: this.filters})
      return form
    },
    async onSubmit() {
      if (this.invalid()) {
        if (this.item === null) {
          await this.createTimable(this.form)
        } else {
          let form = {
            timable_type: this.form.timable_type,
            id: this.form.id,
            timable_id: this.form.timable_id,
            open_at: this.form.timableDate[0] + ' ' + this.form.open_at,
            close_at: this.form.timableDate[1] + ' ' + this.form.close_at,
          }
          await this.$store.dispatch('Timing/updateTiming', form)
          await this.$store.dispatch('Timing/getTimings', {page: this.page, form: this.filters})
        }
      }
    },
    dataLoader() {
      // if we are in create mode we clear timable_type after each time we load data
      // or when in update mode we change timable_type we clear id, to stop conflicting between number in one type to another.
      if (this.item == null || this.item.timable_type !== this.form.timable_type) {
        this.form.timable_id = ''
      }
      this.$store.dispatch(this.typeAttribute.data)
    },
    dataGetter() {
      return this.$store.getters[this.typeAttribute.getter]
    },
    dataSearch() {
      const form = {words: this.searchWords}
      if (this.searchWords.trim().length > 0) {
        return this.$store.dispatch(this.typeAttribute.search, {form})
      }
    },
  },
  mounted() {
    if (this.item !== null) {
      this.form.timableDate = [this.item.open_at.split(' ')[0], this.item.close_at.split(' ')[0]]
      this.form.open_at = this.item.open_at.split(' ')[1]
      this.form.close_at = this.item.close_at.split(' ')[1]
      this.form.timable_type = this.item.timable_type
      this.form.timable_id = this.item.timetable_id
      this.form.id = this.item.id
    }
    this.dataLoader();

  }
}
</script>

<style scoped>

</style>